import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { getAccount, needsDepositLimitsGate } from '@/api';

/** Layout for `/profile/deposits` and `/profile/deposits/$providerId`. */
export const Route = createFileRoute('/profile/deposits')({
  beforeLoad: () => {
    const account = getAccount();
    if (account?.AllowDeposits === false) {
      throw redirect({ to: '/profile' });
    }
    if (needsDepositLimitsGate()) {
      throw redirect({ to: '/profile/deposit-limits' });
    }
  },
  component: ProfileDepositsLayout,
});

function ProfileDepositsLayout() {
  return <Outlet />;
}
